module.exports = __webpack_public_path__ + "img/house_img3.ad8e1bea.png";